import { render } from "./MeetingDetails.vue?vue&type=template&id=5900740b&scoped=true"
import script from "./MeetingDetails.vue?vue&type=script&lang=js"
export * from "./MeetingDetails.vue?vue&type=script&lang=js"

import "./MeetingDetails.vue?vue&type=style&index=0&id=5900740b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5900740b"]])

export default __exports__